import { Temporal } from "temporal-polyfill";

/** Formats an ISO date string as a local, human-readable date + time. */
export function formatTicketDateTime(iso: string): string {
  try {
    const zoned = Temporal.Instant.from(iso).toZonedDateTimeISO(Temporal.Now.timeZoneId());
    return zoned.toPlainDateTime().toString().replace("T", " ").slice(0, 16);
  } catch {
    return iso;
  }
}
